var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLupa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 56,
    viewBox: "0 0 248 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8154_18648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.333 25.5047L120.417 30.5881L130.583 20.4214M148.375 50.9213L137.446 39.9921M143.292 25.5047C143.292 36.7345 134.188 45.8381 122.958 45.8381C111.729 45.8381 102.625 36.7345 102.625 25.5047C102.625 14.2749 111.729 5.17139 122.958 5.17139C134.188 5.17139 143.292 14.2749 143.292 25.5047Z",
    stroke: "#60A5FA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8154_18648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLupa);
export default __webpack_public_path__ + "static/media/icon-lupa.400666041d8cf33639e015e7903dba60.svg";
export { ForwardRef as ReactComponent };